module.exports = __webpack_public_path__ + "img/IMG_9033_L_Black_MockedUp.a6a19518.jpg";